<template>
    <v-layout v-show="moduleBlock === true">
        <v-layout>
            <v-flex class="xs12">
                <v-flex class="xs12">
                    <v-select
                            :items="moduleGroups"
                            label="Группа модулей"
                            v-model="messageModel.module_group_id"
                            item-text="title"
                            item-value="id"
                            @change="changeModuleGroup"
                    ></v-select>
                </v-flex>
                <v-flex class="xs12">
                    <v-text-field
                            v-model="messageModel.error"
                            :counter="28"
                            label="Сообщение при ошибке модуля"
                            required
                            v-on:change="saveValue"
                    ></v-text-field>
                </v-flex>
            </v-flex>
        </v-layout>
    </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'MessageModuleBlock',
    props: ['moduleBlock', 'messageModel'],
    methods: {
        changeModuleGroup() {
            if (this.messageModel.module_group_id === 0) {
                this.messageModel.error = ''
                this.$emit('hideBlock')
            }
            this.saveValue()
        },
        saveValue() {
            this.$emit('saveMessage')
        }
    },
    watch: {
        messageModel() {
            if (this.messageModel.module_group_id !== 0 && this.messageModel.module_group_id !== null) {
                this.$emit('showBlock')
            } else {
                this.$emit('hideBlock')
            }
        }
    },
    computed: {
        ...mapGetters({
            moduleGroups: 'moduleGroups/moduleGroupsForSelectGroup'
        })
    },
    created() {
        if (this.messageModel.module_group_id !== 0 && this.messageModel.module_group_id !== null) {
            this.$emit('showBlock')
        } else {
            this.$emit('hideBlock')
        }
        this.$store.dispatch('moduleGroups/loadModuleGroups', this.$route.params['pathMatch'])
    }
}
</script>

<style scoped>

</style>
